import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import api from "../api/client";

interface User { id:string; phone:string; first_name:string; last_name:string; kyc_status:string; role:string; status:string; email:string; created_at:string }
interface Member {user_id:string; member_no:string; first_name:string; last_name:string; kyc_status:string; role:string; status:string;}
interface Ctx  { user:User|null; login(e:string,p:string):Promise<void>; logout():void; isLoading:boolean; member: Member|null; isMemberLoading:boolean; memberError:string}

const AuthCtx = createContext<Ctx>(null!);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }:{ children:ReactNode }) {
  const [user, setUser] = useState<User|null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [member, setMemberInfo] = useState<Member|null>(null);
  const [isMemberLoading, setIsMemberLoading] = useState(true);
  const [memberError, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setIsLoading(false); return; }
    api.get("/auth/me").then((u:any) => setUser(u)).catch(logout).finally(() => setIsLoading(false));    
  }, []);

  const login = async (phone:string, password:string) => {
    const { token, user:u } = await api.post("/auth/login", { phone, password }) as any;
    localStorage.setItem("token", token);
    setUser(u);
  };
  const logout = () => { localStorage.removeItem("token"); setUser(null); };

  // const memberinfo = async () => {
  //   const M = await api.get("/auth/memberdetails").then((m:any) => setMemberInfo(m)).catch(err => setError('Error: '+ err.message)).finally(() => setIsMemberLoading(false));
  // };

  return <AuthCtx.Provider value={{ user, login, logout, isLoading, member, isMemberLoading,memberError }}>{children}</AuthCtx.Provider>;
}
